import { render } from "./singleBusiness.vue?vue&type=template&id=2eaea82c&ts=true"
import script from "./singleBusiness.vue?vue&type=script&lang=ts"
export * from "./singleBusiness.vue?vue&type=script&lang=ts"

import "./singleBusiness.vue?vue&type=style&index=0&id=2eaea82c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__